import React from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { STYLED_INPUT } from '../../../constants/styles-constants';
import { TextAreaExtended } from './core/text-area-extended';

interface Props {
	maxLength?: number;
	name?: string;
	label?: string;
	required?: boolean;
}

export function ComentarioInput(props: Props) {
	const { name, label, maxLength } = props;

	return (
		<div
			style={{
				marginLeft: '-' + STYLED_INPUT.margin.left,
				marginRight: '-' + STYLED_INPUT.margin.right,
			}}
		>
			<TextAreaExtended
				{...props}
				maxLength={maxLength ?? 300}
				name={name || FIELD_NAME.COMMENT}
				label={label ? label : 'Escríbelo aquí'}
			/>
		</div>
	);
}
